/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';

import { cpfMask, creditCardMask, currencyMask } from '~/utils/masks';

import * as St from './styles';
import TableList from '~/components/tableList';
import Container from '~/components/container';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import { ConsultFindFinancingResponse } from '~/services/consult/user/invoice/antecipationInvoice/response';
import { IlistAntecipacion } from '../model';
import moment from 'moment';
import Loading from '~/components/loading';
import Dialog from '~/components/dialog';
import { icons } from '~/assets';
import { IconBase } from 'react-icons';
import { MdOutlineCopyAll } from 'react-icons/md';
import Popover from '~/components/Popover';
import HeaderConference from '../components/headerConference';

interface ISelectedItem {
  action: Function;
  item: {
    cartao: string;
    cpf: string;
    dataAntecipacao: string;
    dataFechamento: string;
    email: string;
    id: string;
    idParcelamento: string;
    nomeCliente: string;
    parcelasAntecipadas: number;
    status: string;
    tipoAntecipacao: string;
    valorAntecipacao: number;
    qrcodeBase64: string;
    pixCopiaECola: string;
  };
  maxChar: number;
  method: string;
}

const AntecipationHistory: React.FC = () => {
  const [dataPurchase, setDataPurchase] = useState([]);
  const [dialogPix, setDialogPix] = useState({ open: false });
  const [dialogSuccessPix, setDialogSuccessPix] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ISelectedItem>();
  const [popoverPixIsOpen, setPopoverPixIsOpen] = useState(false);
  const [dataClient, setDataClient] = useState({});

  const history = useHistory<any>();
  const locationState = history.location.state;

  const { cpf } = locationState.dataClient;

  const RequestHistoryFinancing = useApi<ConsultFindFinancingResponse>(
    Endpoints.invoices.getAntecipationPurchaseHistory.replace('PARAM_CPF', cpf),
    ApiMethod.GET,
  );

  const RequestEmailAntecipationPix = useApi(
    Endpoints.invoices.postEmailAntecipationPix,
    ApiMethod.POST,
  );

  const historyHeader = [
    {
      id: 1,
      value: 'Status',
      maxChar: 20,
    },
    {
      id: 2,
      value: 'Parcelas antecipadas',
      maxChar: 20,
    },
    {
      id: 3,
      value: 'Valor antecipado',
      maxChar: 20,
    },
    {
      id: 4,
      value: 'Data da antecipação',
      maxChar: 20,
    },
    {
      id: 5,
      value: 'Data do pagamento',
      maxChar: 20,
    },
    {
      id: 6,
      value: 'Origem da antecipação',
      maxChar: 20,
    },
    {
      id: 7,
      value: 'Forma Pagamento',
      maxChar: 20,
    },
    { 
      id: 8, 
      value: '', 
      textAlign: 'center', 
      maxChar: 5 
    },
  ];

  function handleOpenModal(itemData) {
    setSelectedItem(itemData);
    setDialogPix({ open: true });
  }

  const searchHistoryFinancing = async () => {
    const response = await RequestHistoryFinancing.callApi();
    const { data } = response as any;

    setDataClient(data[0] || {});

    if (response.status >= 200 && response.status < 300) { 
      const newData = data.filter((item) => item.tipoAntecipacao === 'COMPRA');

      const newList = [];
      let i = 0;

      newData?.forEach((data) => {
        const item: IlistAntecipacion[] = [
          {
            value: data.status === "FATURAR" ? "A FATURAR" : data.status,
            maxChar: 20,
            textAlign: 'center',
          },
          {
            value: data.parcelasAntecipadas,
            maxChar: 20,
            textAlign: 'center',
          },
          {
            value: `R$ ${currencyMask(data.valorAntecipacao)}`,
            maxChar: 20,
            textAlign: 'center',
          },
          {
            value: data.dataAntecipacao
              ? moment(data.dataAntecipacao).format('DD/MM/YYYY')
              : '-',

            maxChar: 20,
            textAlign: 'center',
          },
          {
            value: data.dataPagamento
              ? moment(data.dataPagamento).format('DD/MM/YYYY')
              : '-',

            maxChar: 20,
            textAlign: 'center',
          },
          {
            value: data.origemAntecipacao ? data.origemAntecipacao : '-',
            maxChar: 20,
            textAlign: 'center'
          },
          {
            value: data?.txId ? "PIX" : "CAIXA",
            maxChar: 20,
            textAlign: 'center',
          },
          {
            item: data,
            maxChar: 5,
            action: (id, item) => handleOpenModal(item),
            method: data?.txId ? "PIX" : "CAIXA",
            type: data?.tipoAntecipacao,
          },
        ];

        newList.push(item);
      });
      setDataPurchase(newList);
    }
  };

  useEffect(() => {
    searchHistoryFinancing();
  }, []);

  const handleSubmit = async () => {
    const payload = {
      email: selectedItem?.item?.email,
      nomeCliente: selectedItem?.item?.nomeCliente,
      valor: selectedItem?.item?.valorAntecipacao,
      pixCopiaECola: selectedItem?.item?.pixCopiaECola,
      qrCodeBase64: selectedItem?.item?.qrcodeBase64,
    };
    try {
      const response = await RequestEmailAntecipationPix.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        setDialogPix({open: false})
        setDialogSuccessPix(true);    
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleHistory = () => {
    history.push('/invoice/antecipation/purchase', {
      cpf: cpfMask(dataClient?.cpf).masked,
    });
  };

  return (
    <>
      <Loading status={RequestHistoryFinancing.loading || RequestEmailAntecipationPix.loading} />
      <Dialog
        icon={icons.check}
        title={'Código PIX'}
        message="E-mail reenviado com sucesso!"
        open={dialogSuccessPix}
        positiveLabel="Entendi"
        positiveAction={() => setDialogSuccessPix(false)}
      />
      <Dialog
        icon={icons.exclamation}
        title={'Código PIX'}
        open={dialogPix.open}
        widthInPercent={30}
        positiveLabel="Reenviar"
        positiveAction={handleSubmit}
        negativeLabel="Voltar"
        negativeAction={() => {
          setDialogPix({ open: false });
        }}
      >
        <ContainerFlex center>
          <ContainerFlex row center gap="8">
            <St.Title style={{ fontWeight: 700, fontSize: '24px' }}>
              Pix copia e cola:
            </St.Title>
            <IconBase
              size={24}
              fontSize={24}
              style={{ cursor: 'pointer' }}
              onClick={async () => {
                await navigator.clipboard.writeText(
                  selectedItem?.item?.pixCopiaECola
                );
                setPopoverPixIsOpen(true);
                setTimeout(() => setPopoverPixIsOpen(false), 3000);
              }}
            >
              <MdOutlineCopyAll />
            </IconBase>
          </ContainerFlex>
          <ContainerFlex marginTop={20}>
            <St.Info>{selectedItem?.item?.pixCopiaECola}</St.Info>
          </ContainerFlex>
        </ContainerFlex>
      </Dialog>
      <div
        style={{
          position: 'absolute',
          zIndex: 999,
          right: '17px',
          top: '2rem',
        }}
      >
        <Popover open={popoverPixIsOpen}>
          <ContainerFlex row center gap="8">
            <img width={16} height={16} src={icons.check} alt="check" />
            <p>Código copiado com sucesso!</p>
          </ContainerFlex>
        </Popover>
      </div>

      <Container>
        <ContainerFlex padding={16}>
          <ContainerFlex row space padding={22} wrap>
            <ContainerFlex row padding={22} style={{ flex: 1 }}>
              <HeaderConference
                nomeCompleto={dataClient?.nomeCliente}
                cpf={dataClient?.cpf}
                numeroCartao={dataClient?.cartao}
                historyAntecipation              
              />
            </ContainerFlex>
          </ContainerFlex>

          <ContainerFlex padding={16}>
            <St.MainHeader>Histórico de antecipação de compra</St.MainHeader>
            <TableList customerHeader={historyHeader} list={dataPurchase} />
          </ContainerFlex>
        </ContainerFlex>
      </Container>
    </>
  );
};

export default AntecipationHistory;
